import { render, staticRenderFns } from "./BaseProperty.vue?vue&type=template&id=5b662d30&"
import script from "./BaseProperty.vue?vue&type=script&lang=js&"
export * from "./BaseProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports